(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('InvoicesController', InvoicesController);

    function InvoicesController($translate, $localStorage, $uibModal, $stateParams, $state, $window, Principal, InvoicesService, InvoiceUtilsService, StoreService, toastr, ModalFactory, systemConstants, $scope) {
        var vm = this;

        vm.flyersFiltered = [];
        vm.sellerId = $stateParams.sellerId ? $stateParams.sellerId : undefined;

        vm.startDate = {
            startDate: null,
            endDate: null
        };

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalCustomers = 0;
        vm.currencyPrefix = 'R$';

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.invoiceList = [];

        vm.paymentLinkEnabled = InvoiceUtilsService.isPaymentLinkEnabled();
        vm.canCopyPaymentLink = InvoiceUtilsService.canCopyPaymentLink;
        vm.canRegeneratePaymentLink = InvoiceUtilsService.canRegeneratePaymentLink;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.selectedPaymentLink = null;
        vm.paymentLinkDrawerVisible = false;

        vm.filter = {
            transactionTypes: ["SALE", "PAYMENT_LINK"],
            externalChannel: null
        };
        vm.account = undefined;
        vm.userProfile = undefined;
        vm.isAmbassador = false;

        vm.externalChannelOptions = InvoiceUtilsService.getExternalChannelOptions();

        vm.statusOptions = [
            { value: 'WAITING_CONFIRMATION', label: $translate.instant('invoice.states.waitingConfirmation') },
            { value: 'CONFIRMED',            label: $translate.instant('invoice.states.confirmed') },
            { value: 'SEPARATING',           label: $translate.instant('invoice.states.separating') },
            { value: 'AVAILABLE_TO_DELIVERY',label: $translate.instant('invoice.states.availableToDelivery') },
            { value: 'DELIVERED',            label: $translate.instant('invoice.states.delivered') },
            { value: 'WAITING_PAYMENT',      label: $translate.instant('invoice.states.waiting') },
            { value: 'PAID',                 label: $translate.instant('invoice.states.paid') },
            { value: 'NOT_PAID',             label: $translate.instant('invoice.states.notPaid') },
            { value: 'CANCELLED',            label: $translate.instant('invoice.states.cancelled') },
            { value: 'REVERTED',             label: $translate.instant('invoice.states.reverted') }
        ];

        init();

        function init() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                    vm.userProfile = vm.account.userProfiles[0];
                    vm.isAmbassador = vm.userProfile.profileId === systemConstants.AMBASSADOR_PROFILE_ID;
                    loadInvoiceList(vm.paginationOptions, vm.filter);
                }
            });
            
        }

        function loadInvoiceList(pagination, filter) {
            vm.loadingInvoices = true;
            if (vm.isAmbassador) {
                vm.filter.sellerId = vm.account.id;
            }
            InvoicesService.list(pagination, filter).then(function (result) {
                if (result.data) {
                    vm.invoiceList = result.data.content;
                    vm.invoiceList.forEach(function (transaction){
                        transaction.currencyPrefix = getCurrencyPrefix(transaction);
                    });
                    vm.totalInvoices = result.data.totalElements;
                    var begin = (vm.currentPage - 1) * vm.numPerPage;
                    vm.startRegistry = vm.totalInvoices > 0 ? begin + 1 : 0;
                    vm.endRegistry = Math.min(begin + vm.numPerPage, vm.totalInvoices);
                    vm.loadingInvoices = false;
                }
            }, function (error) {
                vm.loadingInvoices = false;
            });
        }

        function getCurrencyPrefix(transaction) {
            var key = transaction.currency ? transaction.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        vm.openModalDetail = function(invoice) {
            ModalFactory.openDetailInvoice(invoice, vm.userProfile, vm.paymentLinkEnabled).then(function (result) {
                if (result && result.invoice) {
                    vm.openRefundModal(result.invoice);
                } else {
                    loadInvoiceList(vm.paginationOptions, vm.filter);
                }
            });
        }

        vm.copyPaymentLink = function (invoice) {
            InvoiceUtilsService.copyPaymentLink(invoice.uuid);
        };

        vm.openPaymentLinkDrawer = function (invoice) {
            if (!vm.isMobile || !InvoiceUtilsService.canCopyPaymentLink(invoice)) {
                return;
            }
            vm.selectedPaymentLink = invoice;
            vm.paymentLinkDrawerVisible = true;
        };

        vm.regeneratePaymentLink = function (invoice) {
            $state.go('invoices.new', {
                cloneFromUuid: invoice.uuid,
                cloneCustomerId: invoice.customer ? invoice.customer.id : null,
                cloneCustomerIdentity: invoice.customer ? invoice.customer.customerIdentity : null
            });
        };

        vm.openRefundModal = function (data) {
            vm.magicModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/invoices/refund/refund-magic-modal.html',
                controller: 'RefundMagicModalController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                resolve: {
                    invoice: function () {
                        return data
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                loadInvoiceList(vm.paginationOptions, vm.filter);
            });
        };

        vm.changePage = function () {
            var begin = (vm.currentPage - 1) * vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            loadInvoiceList(vm.paginationOptions, vm.filter);
        }

        vm.updateStatus = function(invoice, status) {
            vm.isSaving = true;
            InvoicesService.updateTransactionStatus(invoice.id, status).then(function(result) {
                toastr.success($translate.instant('invoice.home.messages.saveSuccess'));
                invoice.status = status;
                vm.isSaving = false;
            }).catch(function(err) {
                toastr.error($translate.instant('invoice.home.messages.noItens'));
                vm.isSaving = false;
            });
        }


        vm.filterInvoices = function() {
            vm.filter.status = vm.filter.status == "" ? null : vm.filter.status
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            loadInvoiceList(vm.paginationOptions, vm.filter);
        };

        // Aguarda o binding do select atualizar o filtro antes de enviar a busca.
        $scope.$watch(function () {
            return vm.filter.status || null;
        }, function (status, previousStatus) {
            if (status !== previousStatus) {
                vm.filterInvoices();
            }
        });

        $scope.$watch(function () {
            return vm.filter.externalChannel;
        }, function (externalChannel, previousExternalChannel) {
            if (externalChannel !== previousExternalChannel) {
                vm.filterInvoices();
            }
        });

        vm.maskPrice = function (value, currencyKey) {
            var currencyConfiguration = getCurrencyListConfiguration()[currencyKey];
            return formatMoney(value, currencyConfiguration.prefix, currencyConfiguration.decimalQuant, currencyConfiguration.centsSeparator, currencyConfiguration.thousandsSeparator);
        }
    }
})();
